import * as LoginActions from 'auth/actions';
import { ROUTES } from 'global/constants';
import * as React from 'react';
import { MessageDescriptor } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    StandardPageLayout,
    Button
} from 'ui/components';

interface Props extends RouteComponentProps<{}>{
    title: string;
    body: string;
    primaryButtonText?: MessageDescriptor;
    primaryButtonOnClick?: () => void;
    secondaryButtonText?: MessageDescriptor;
    secondaryButtonOnClick?: () => void;
    image: string;
    headerFeature?: React.ReactNode;
    footerFeature?: React.ReactNode;
    /// [false] if you want to put the registration gate in the header
    /// [true] if you want to put the registration gate in the body
    contentInBody?: boolean;
}

export class RegistrationGateInternal extends React.PureComponent<Props> {

    public render() {
      return (
          <div className='library-registration-gate-wrapper'>
              <StandardPageLayout
                  headerFeature={
                      <div className='testtt'>
                          {this.props.headerFeature}
                          {this.props.contentInBody !== true && this.renderRegistrationGate()}
                      </div>
                  }
                  headerFeatureContainer={(this.props.contentInBody !== true)}
                  footerFeature={this.props.footerFeature}
              >
                  {this.props.contentInBody === true && this.renderRegistrationGate()}
              </StandardPageLayout>
          </div>
      );
    }

    private renderRegistrationGate() {
        let containerClassName = 'container alert-container';
        if (this.props.contentInBody === true) {
            containerClassName += ' alert-body';
        }
        return (
            <div className={containerClassName}>
                 <img src={this.props.image} alt='' />
                 <div>
                    <h1>{this.props.title}</h1>
                    <h2>{this.props.body}</h2>
                 </div>
                 <div className='alert-buttons'>
                    {this.props.secondaryButtonText ? <Button
                        btnStyle='outline'
                        label={this.props.secondaryButtonText}
                        onClick={this.props.secondaryButtonOnClick || this.handleLogin}
                    />: null}
                    {this.props.primaryButtonText ? <Button
                        btnStyle='primary'
                        label={this.props.primaryButtonText}
                        onClick={this.props.primaryButtonOnClick || this.handleSignup}
                    />: null}
                 </div>
            </div>
        );
    }

    private handleLogin = () => {
        LoginActions.redirectToLogin();
    }

    private handleSignup = () => {
        this.props.history.push(ROUTES.General.SIGN_UP);
    }
}

export const RegistrationGate = connect<Props>(
    null, null,
)(withRouter(RegistrationGateInternal));
